export default __webpack_public_path__ + "img/close-small.75a205ac.svg";